import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-xls-viewer',
  templateUrl: './xls-viewer.component.html',
  styleUrls: ['./xls-viewer.component.css']
})
export class XlsViewerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./public/app/common/xls-viewer/xls-viewer.component.ts